<template>
    <div class="print">
        <schedule :show-style="showStyle" print @inited="handleExport" id="schedule-print"/>
    </div>
</template>

<script>
import Core from '@/core';
import Schedule from './components/schedule/Schedule';
import html2canvas from 'html2canvas';
import { timeFilter } from '@/core/filters/index.js'

export default {
    components: {
        Schedule
    },
    data() {
        return {
            showStyle: '',
            token: Core.Data.getToken(),
            userType: Core.Data.getUserType(),
        }
    },

    created() {
        this.showStyle = this.$route.query.show_style;
        this.token = Core.Data.getToken() || this.$route.query.token;
        this.userType = Core.Data.getUserType() || Core.Const.USER_TYPE.PROVIDER;
        Core.Data.setToken(this.$route.query.token);
        Core.Data.setUserType(this.userType);
    },

    mounted() {
    },

    methods: {
        handleExport(course) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.exportToImage(course);
                }, 1000); // 延迟1秒确保内容完全渲染
            });
        },
        async exportToImage(course = {}) {
            try {
                const element = document.querySelector('#schedule-print');
                if (!element) {
                    console.error('找不到要导出的元素');
                    return;
                }

                // 配置 html2canvas 选项
                const options = {
                    scale: 2, // 提高分辨率
                    useCORS: true, // 允许跨域图片
                    allowTaint: false,
                    backgroundColor: '#ffffff', // 设置白色背景
                    width: element.offsetWidth,
                    height: element.offsetHeight,
                    logging: false, // 关闭日志
                };

                // 生成 canvas
                const canvas = await html2canvas(element, options);

                // 转换为图片并下载
                const image = canvas.toDataURL('image/png', 1.0);
                this.downloadImage(image, course.name ? `课程表-${course.name}-${timeFilter(course.beginTime, 4)}至${timeFilter(course.endTime, 7)}` : `课程表-${Date.now()}.png`);

            } catch (error) {
                console.error('导出图片失败:', error);
                this.$message.error('导出图片失败，请重试');
            }
        },

        downloadImage(dataUrl, filename) {
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
};
</script>
<style lang="scss" scoped>
.print {
    &::before {
        // content: '';
        position: fixed;
        display: inline-block;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 999;
    }
}
</style>
